import React from 'react'
import clsx from 'clsx'

// Cube
import { classToFComponent, type FCClassContext } from 'cube-react'

import Icons from '@/shared/AppIcons'
import Sel from './styles-consts'

import { CompareTableScope } from '../analise-bulas.scope'

const styles = {
    flatCard: {
        padding: 0,
        border: 'none',
        boxShadow: 'none'
    },
    gap2x: {
        columnGap: 'var(--spacing-scale-2x)'
    }
} satisfies Record<string, React.CSSProperties>

// :: CompareTableView Component

export type CompareTableProps = {
    className?: string
    scope: CompareTableScope
}

class CompareTableViewClass implements FCClassContext<CompareTableProps> {
    scope!: CompareTableScope

    render({ scope, className }: CompareTableProps) {
        this.scope = scope

        if (!scope.reacaoPorFabricanteData) {
            return <></>
        }

        return (
            <div className={clsx(className)}>
                {/* --- Cards de Resumo --- */}
                <div className={clsx(Sel.dFlex, Sel.flexColumnGapBase, Sel.mb('base'))}>
                    <ValueCard
                        title="Fabricantes Analisados"
                        label="Bulas comparadas"
                        iconUrl={Icons.buildingUrl}
                        value={scope.qtdeFabricatesAnalisados}
                    />
                    <ValueCard
                        title="Cobertura Completa"
                        label="Reações em todas as bulas"
                        iconUrl={Icons.circleCheckBigUrl}
                        value={scope.qtdeCoberturasCompletas}
                    />
                    <ValueCard
                        title="Cobertura Parcial"
                        label="Inconsistências detectadas"
                        iconUrl={Icons.triangleAlertUrl}
                        value={scope.qtdeCoberturaParciais}
                    />
                    <ValueCard
                        title="Não Documentadas"
                        label="Reações ausentes em bulas"
                        iconUrl={Icons.circleXUrl}
                        value={scope.qtdeNaoDocumentadas}
                    />
                </div>

                {/* --- TABELA EXCEL-STYLE --- */}
                <div className={clsx(Sel.flatCard, Sel.mt('base'), className)} style={styles.flatCard}>
                    {/* Container com scroll duplo e sticky headers */}
                    <div className={Sel.matrixContainer}>
                        <table className={Sel.matrixGrid}>
                            <thead>
                                <tr>
                                    {/* Canto Superior Esquerdo Fixo */}
                                    <th>
                                        <div className={Sel.matrixCornerHeader}>Reação Adversa</div>
                                    </th>

                                    {/* Cabeçalhos Verticais dos Fabricantes */}
                                    {scope.reacaoPorFabricanteData.fabricantes.map((item) => (
                                        <th key={item.id}>
                                            <div className={Sel.matrixVerticalTextHeader} title={item.nome}>
                                                {item.nome}
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {scope.reacaoPorFabricanteData.rows.map((item) => (
                                    <tr key={item.id}>
                                        {/* Coluna Fixa à Esquerda (Reação) */}
                                        <th>{item.reacao}</th>

                                        {/* Células de Dados */}
                                        {item.medicamentos.map((medicamentosReagentes, idx) => (
                                            <td key={idx}>
                                                {medicamentosReagentes.length > 0 ? (
                                                    // CASO TENHA MEDICAMENTO: Badge Azul
                                                    <div
                                                        className={Sel.matrixCellMedBadge}
                                                        title={medicamentosReagentes
                                                            .map((m) => m.nome)
                                                            .join('\n')}
                                                    >
                                                        {medicamentosReagentes[0].nome}
                                                        {medicamentosReagentes.length > 1 && (
                                                            <small> (+{medicamentosReagentes.length - 1})</small>
                                                        )}
                                                    </div>
                                                ) : (
                                                    // CASO NÃO TENHA: Traço sutil
                                                    <span className={Sel.matrixMedMissing}>&mdash;</span>
                                                )}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

export default classToFComponent(CompareTableViewClass)

// :: ValueCard Component

type ValueCardProps = {
    className?: string
    title: string
    label: string
    iconUrl: string
    value: number
}

function ValueCard({ className, title, label, iconUrl, value }: ValueCardProps) {
    return (
        <div className={clsx(Sel.flatCard, Sel.p('base'), className)}>
            <div className={clsx(Sel.brCardContent, Sel.totalCardFabricantes)}>
                <div className={clsx(Sel.dFlex, Sel.alignContentCenter)} style={styles.gap2x}>
                    <span className={clsx(Sel.textBase, Sel.textWeightBold, Sel.flexGrow1)}>{title}</span>
                    <img src={iconUrl} width="16" height="16" alt="icon" />
                </div>
                <span className={clsx(Sel.textUp02, Sel.textWeightBold)}>{value}</span>
                <span className={clsx(Sel.textDown02)}>{label}</span>
            </div>
        </div>
    )
}
